import { createContext } from 'react';

import { useGetSiteInfo } from './hooks/useGetSiteInfo';
import { SiteInfo } from './types';

const SiteInfoContext = createContext<SiteInfo | undefined>(undefined);

const SiteInfoProvider = ({ children }: React.PropsWithChildren) => {
  const siteInfo = useGetSiteInfo();
  return (
    <SiteInfoContext.Provider value={siteInfo}>
      {children}
    </SiteInfoContext.Provider>
  );
};

export { SiteInfoContext, SiteInfoProvider };
